const WalletBar = () => {	
    return(
        <>  
		
        </>
    )
}

export default WalletBar;